import moment from 'moment';
// Type only, and moment rather than utilis' isSameDate: utilis pulls in the whole store, so this file stays testable
import type { ShiftCapsulesByPassenger } from 'src/store/slices/manualOrders/types';

const isSameDate = (a: Date, b: Date) => moment(a).isSame(moment(b), 'day');

/**
 * The selected passengers that have the same shift (date and times) as the clicked one, in selection order.
 * Deleting or editing "for all the selected passengers" acts on exactly these (customer request, 2026-11-02);
 * empty when the clicked passenger is not selected, because then the action is for that passenger alone.
 */
export const selectedWithSameShift = (
    clicked: { passId: string; date: Date; times: string },
    selectedIds: string[],
    capsulesByPassenger?: ShiftCapsulesByPassenger
): string[] => {
    if (!capsulesByPassenger || !selectedIds.includes(clicked.passId)) return [];

    return selectedIds.filter((passId) =>
        (capsulesByPassenger[passId] || []).some(
            (capsule) => capsule.times === clicked.times && isSameDate(capsule.date, clicked.date)
        )
    );
};

const scopeHelpers = { selectedWithSameShift };

export default scopeHelpers;
